/* eslint-disable multiline-ternary */
import { Box, Typography, withStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGlobalState } from '../../providers/GlobalState'
import { HelpPost } from '../../types/graphql'
import { SuccessButton, WarningButton } from '../Buttons'
import HelpForm from './HelpForm'

interface Params {
  origin: string
}

export const ButtonBox = withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'space-between',
    width: '100%'
  }
}))(Box)

export const HelpLayout: React.FC = () => {
  const [form, setForm] = useState<boolean>(false)
  const [active, setActive] = useState<HelpPost | null | undefined>()
  const { origin } = useParams<Params>()
  const { helpers } = useGlobalState()
  useEffect(() => {
    if (helpers) {
      if (helpers.find(x => x?.slug === origin)) {
        setActive(helpers.find(x => x?.slug === origin))
      } else {
        setActive(helpers.find(x => x?.slug === 'default'))
      }
    }
  }, [helpers])

  return (
    <>
      {form ? (
        <HelpForm helperId={active?.id} />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100vh',
            padding: '30px 0',
            justifyContent: 'center',
            backgroundColor: '#fff'
          }}
        >
          <Typography variant="h2">{active?.name}</Typography>
          <div
            style={{ margin: '50px 0', width: '50%', textAlign: 'justify' }}
            dangerouslySetInnerHTML={{
              __html: active?.description || ''
            }}
          ></div>
          {active?.movie && (
            <video
              width="50%"
              style={{ marginBottom: 100, marginTop: 20 }}
              controls
            >
              <source src={active?.movie || ''} type="video/mp4" />
              Your browser does not support HTML video.
            </video>
          )}
          {active?.thumb && (
            <img
              width="50%"
              style={{ marginBottom: 100, marginTop: 20 }}
              src={active.thumb}
              alt={active.name}
            />
          )}
          <br />
          <ButtonBox>
            <SuccessButton variant="contained">
              Informação foi útil!
            </SuccessButton>
            <WarningButton variant="contained" onClick={() => setForm(true)}>
              Ainda estou com dúvida
            </WarningButton>
          </ButtonBox>
          <br />
        </div>
      )}
    </>
  )
}
